<template>
  <div class="signin_logo">
    <div class="logo">
      <img class="top-logo" v-if="headerLogo && headerLogo.length > 0" :src="headerLogo | imgFormat" alt="" />
      <div class="top-logo" v-else></div>
    </div>
    <div class="schedule">
      <div class="schedule_time">{{ timeString }}</div>
      <div class="schedule_date">{{ dateString }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerLogo: dsf.config.setting_screen_vertical_top_picture,
      weekArr: [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ],
      timeString: "",
      dateString: "",
      timer: null,
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    updateTime() {
      let nowDate = new Date();
      this.timeString =
        this.formatTime(nowDate.getHours(), 2) +
        ":" +
        this.formatTime(nowDate.getMinutes(), 2);
      this.dateString =
        nowDate.getFullYear() +
        "年" +
        (nowDate.getMonth() + 1) +
        "月" +
        nowDate.getDate() +
        "日" +
        " " +
        this.weekArr[nowDate.getDay()];
    },
    formatTime(num, digit) {
      let zero = "";
      for (let i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
  },
};
</script>

<style>
</style>